var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMfDiscoverLoaderProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 48,
    viewBox: "0 0 128 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "mfDiscoverLoaderProgressTitle"
  }, "MF Discover loading progress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "mfDiscoverLoaderProgressTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "mfDiscoverLoaderProgressDesc"
  }, "Three diagonal blue progress bars reveal one after another.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "activeFill",
    x1: 24,
    y1: 42,
    x2: 96,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2818FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4C4EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97AAFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "skewX(-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 10,
    width: 14,
    height: 28,
    fill: "#2818FF",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 10,
    width: 14,
    height: 28,
    fill: "#2818FF",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 10,
    width: 14,
    height: 28,
    fill: "#2818FF",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 10,
    width: 14,
    height: 28,
    fill: "url(#activeFill)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    keyTimes: "0;0.2;0.76;1",
    dur: "2.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 10,
    width: 14,
    height: 28,
    fill: "url(#activeFill)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1;0",
    keyTimes: "0;0.2;0.42;0.82;1",
    dur: "2.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 10,
    width: 14,
    height: 28,
    fill: "url(#activeFill)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1;0",
    keyTimes: "0;0.4;0.62;0.9;1",
    dur: "2.8s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfDiscoverLoaderProgress);
export default __webpack_public_path__ + "static/media/mf-discover-loader-progress.0105ea983b6e1665fafcd6ec33fa7d36.svg";
export { ForwardRef as ReactComponent };